export function pipe(...fns) {
    return (arg) => fns.reduce((prev, fn) => fn(prev), arg);
}
